import { newToolFilterOAuthMcp } from "../oauth.ts";

export const supermetricsMcpResolver = newToolFilterOAuthMcp({
  iconUrl: "https://supermetrics.com/favicon.png",
  url: "https://mcp.supermetrics.com/mcp",
  label: "Supermetrics",
});
